//加盟商
import allianceHome from '@/components/alliance/home.vue'
//设备信息
import allianceMacHome from '@/components/alliance/mac/home.vue'
import allianceMacList from '@/components/alliance/mac/list.vue'
//货道信息
import allianceMacAisleHome from '@/components/alliance/mac/aisle/home.vue'
import allianceMacAisleList from '@/components/alliance/mac/aisle/list.vue'
import allianceMacAisleUpdate from '@/components/alliance/mac/aisle/update.vue'

//报表信息
import allianceFinanceHome from '@/components/alliance/finance/home.vue'
import allianceFinanceList from '@/components/alliance/finance/list.vue'
import allianceFinanceList1 from '@/components/alliance/finance/list1.vue'
import allianceFinanceListMac from '@/components/alliance/finance/listMac.vue'

//设备订单信息
import allianceMacOrderHome from '@/components/alliance/macOrder/home.vue'
import allianceMacOrderList from '@/components/alliance/macOrder/list.vue'
//设备订单详情
import allianceMacOrderDetailsHome from '@/components/alliance/macOrder/details/home.vue'
import allianceMacOrderDetailsList from '@/components/alliance/macOrder/details/list.vue'


//统计信息
import allianceCommodityFinanceTongjiHome from '@/components/alliance/finance/tongji/home.vue'
import allianceCommodityFinanceTongjiList from '@/components/alliance/finance/tongji/commList.vue'
import allianceCommodityFinanceTypeTongjiList from '@/components/alliance/finance/tongji/commTypeList.vue'
//报表信息
import allianceBaobiaoHome from '@/components/alliance/finance/baobiao/home.vue'
import allianceBaobiaoList from '@/components/alliance/finance/baobiao/heji.vue'
import allianceBaobiaoYear from '@/components/alliance/finance/baobiao/year.vue'
import allianceBaobiaoMonth from '@/components/alliance/finance/baobiao/month.vue'
import allianceBaobiaoDay from '@/components/alliance/finance/baobiao/day.vue'
export default [{
		path: 'alliance',
		name: 'alliance',
		component: allianceHome,
		children: [{ //设备信息
			path: 'mac',
			name: 'mac',
			component: allianceMacHome,
			children: [{
				path: 'list',
				name: 'alliance/mac/list',
				component: allianceMacList
			}, { //货道信息
				path: 'mac/aisle',
				name: 'mac/aisle',
				component: allianceMacAisleHome,
				children: [{
					path: 'list',
					name: 'alliance/mac/aisle/list',
					component: allianceMacAisleList
				},{
					path: 'update',
					name: 'alliance/mac/aisle/update',
					component: allianceMacAisleUpdate
				}]
			}]
		},{ //报表信息
			path: 'finacce',
			name: 'finacce',
			component: allianceFinanceHome,
			children: [{
				path: 'list',
				name: 'alliance/finance/list',
				component: allianceFinanceList,
				meta: {
					 keepAlive: true // 需要缓存
				}
			},{
				path: 'list1',
				name: 'alliance/finance/list1',
				component: allianceFinanceList1,
				meta: {
					 keepAlive: true // 需要缓存
				}
			},{
				path: 'list/mac',
				name: 'alliance/finance/list/mac',
				component: allianceFinanceListMac,
				meta: {
					 keepAlive: true // 需要缓存
				}
			}]
		},{ //设备订单信息
			path: 'macOrder',
			name: 'macOrder',
			component: allianceMacOrderHome,
			children: [{
				path: 'list',
				name: 'alliance/mac/order/list',
				component: allianceMacOrderList
			}, { //货道信息
				path: 'macOrder/details',
				name: 'macOrder/details',
				component: allianceMacOrderDetailsHome,
				children: [{
					path: 'list',
					name: 'alliance/mac/order/details/list',
					component: allianceMacOrderDetailsList
				}]
			}]
		},{ //报表管理
		path: 'finance/tongji',
		name: 'finance/tongji',
		component: allianceCommodityFinanceTongjiHome,
		children: [{
			path: 'list1',
			name: 'alliance/finance/tongji/list1',
			component: allianceCommodityFinanceTongjiList,
		},{
			path: 'list2',
			name: 'alliance/finance/tongji/list2',
			component: allianceCommodityFinanceTypeTongjiList
		}]
	},
	{ 
		path: 'baobiao',
		name: 'baobiao',
		component: allianceBaobiaoHome,
		children: [{
			path: 'list/hj',
			name: 'alliance/baobiao/list/hj',
			component: allianceBaobiaoList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		},{
			path: 'list/year',
			name: 'alliance/baobiao/list/year',
			component: allianceBaobiaoYear,
			meta: {
				 keepAlive: true // 需要缓存
			}
		},{
			path: 'list/month',
			name: 'alliance/baobiao/list/month',
			component: allianceBaobiaoMonth,
			meta: {
				 keepAlive: true // 需要缓存
			}
		},{
			path: 'list/day',
			name: 'alliance/baobiao/list/day',
			component: allianceBaobiaoDay,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}]
	}]
}]


// WEBPACK FOOTER //
// ./src/router/alliance/alliance.js